class WpLogin {
    constructor() {

        if (typeof TheeAdmin !== undefined) {
            this.url = {
                home: TheeAdmin.url.home,
                tpl: TheeAdmin.url.tpl,
                ajax: TheeAdmin.url.ajax,
                logo: TheeAdmin.url.logo
            };

            this.path = {
                tpl: TheeAdmin.path.tpl
            };

            document.addEventListener("DOMContentLoaded", this.init.bind(this));
        }

    }

    init() {
        /**
         *
         * @type {HTMLElement}
         */
        this.loginEl = document.getElementById("login");
        /**
         *
         * @type {HTMLDivElement}
         */
        this.loginHolderEl = document.createElement("div");

        if (this.loginEl) {
            this.replaceLogo();
            this.restructureDOM();

            window.addEventListener("resize", e => {
                this.resize();
            });

            this.resize();
        }
    }

    restructureDOM() {
        const loginAreaEl = document.createElement("div");
        const supportHolderEl = document.createElement("div");
        const forgotPwdEl = this.loginEl.querySelector(".forgetmenot");
        const goBackEl = this.loginEl.querySelector("#nav");
        const rowEl = document.createElement("div");
        const scrollForSupportEl = document.createElement("a");

        supportHolderEl.classList.add("support-holder", "col-xl-4", "col-lg-5", "col-12", );
        loginAreaEl.classList.add("login-area", "row", "no-gutters");
        rowEl.classList.add("remember-back");

        scrollForSupportEl.classList.add("scroll-down");
        scrollForSupportEl.href = "#login-support";
        scrollForSupportEl.innerHTML = this.getScrollForSupportHtml();

        this.loginHolderEl.classList.add("login-holder", "col-xl-8", "col-lg-7", "col-12");
        this.loginEl.querySelector(".privacy-policy-page-link").remove();
        this.loginEl.after(this.loginHolderEl);

        this.loginHolderEl.append(this.loginEl);
        this.loginHolderEl.after(loginAreaEl);
        loginAreaEl.append(this.loginHolderEl);

        supportHolderEl.innerHTML = this.getSupportHolderHtml();
        this.loginHolderEl.after(supportHolderEl);

        goBackEl.after(rowEl);
        if (forgotPwdEl) {
            rowEl.append(forgotPwdEl);
        }
        rowEl.append(goBackEl);

        rowEl.after(scrollForSupportEl);

        scrollForSupportEl.addEventListener("click", (e) => {
            e.preventDefault();
            window.scrollTo({
                top: document.getElementById("login-support").offsetTop,
                behavior: "smooth"
            });
        });
    }

    replaceLogo() {
        /**
         *
         * @type {HTMLLinkElement}
         */
        const logoEl = this.loginEl.querySelector("h1 a");
        if (logoEl) {
            logoEl.style.backgroundImage = `url(${this.url.logo})`;
        }
    }

    resize() {
        let hw = window.innerHeight;
        this.loginHolderEl.style.height = hw + "px";
    }

    getSupportHolderHtml() {
        return `
        <div id="login-support">
                <div class="thee-logo-holder">
                    <a href="https://theedigital.com" 
                        class="thee-logo" target="_blank"><img src="${this.url.tpl}/dist/img/theedigital-logo.png" alt="TheeDigital"/></a>
                    <div class="logo-under">
                        <h4>Request Website Support!</h4>
                    </div>
                </div>
                <div class="contact-methods">
                    <div class="contact-method phone">
                        <div class="icon-holder"><i class="fa fa-phone"></i></div>
                        <div class="information">
                            <div class="line-1">Sales: (919) 341-8901</div>
                            <div class="line-2"><a href="https://theedigital.com/contact" target="_blank">TheeDigital.com/contact</a></div>
                        </div>
                    </div>
                    <div class="contact-method email">
                        <div class="icon-holder"><i class="fa fa-envelope"></i></div>
                        <div class="information">
                            <div class="line-1">Support: (919) 322-4750</div>
                            <div class="line-2"><a href="https://theedigital.com/support" target="_blank">TheeDigital.com/support</a></div>
                        </div>
                    </div>
                    <div class="contact-method training">
                        <div class="icon-holder"><i class="fa fa-globe"></i></div>
                        <div class="information">
                            <div class="line-1">Free WordPress and SEO Training</div>
                            <div class="line-2"><a href="https://www.theedigital.com/about/events" target="_blank">TheeDigital.com/training</a></div>
                        </div>
                    </div>
                    <div class="contact-method location">
                        <div class="icon-holder"><i class="fa fa-map-marker"></i></div>
                        <div class="information">
                            <div class="line-1">Office</div>
                            <div class="line-2"><a href="https://goo.gl/maps/BtsV7p8roDFNUXvu8" target="_blank">7901 Strickland Road, Suite 112<br/>Raleigh, NC 27615</a></div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    getScrollForSupportHtml() {
        return `
            <p>Scroll down for Support!</p>
            <img src="${this.url.tpl}/dist/img/scroll-down.png" alt="scroll down for support" />
        `;
    }


}

export default WpLogin;